import { ContainerModule } from "inversify";
import * as Api from "@/app/question/components/api";
import * as SerializationApi from '@/app/state-serialization/api';
import SortingQuestionComponent from "./sorting-question-component.vue";
import SortingQuestionSolutionComponent from "./sorting-question-solution-component.vue";
import { SortingQuestionStateProtobufSerializer } from "./sorting-question-state-protobuf-serializer";
import { SortingQuestionAnswerProtobufSerializer } from "./sorting-question-answer-protobuf-serializer";

export const sortingQuestionFactoryModule = new ContainerModule(bind => {
  bind<Api.QuestionComponentPlugin>(Api.QuestionComponentPluginSymbol)
    .toConstantValue(SortingQuestionComponent)
    .whenTargetNamed("sorting");

  bind<Api.QuestionComponentPlugin>(Api.QuestionSolutionPluginSymbol)
    .toConstantValue(SortingQuestionSolutionComponent)
    .whenTargetNamed("sorting");

    bind(SerializationApi.StateSerializationPluginSymbol).to(SortingQuestionAnswerProtobufSerializer)
    bind(SerializationApi.StateSerializationPluginSymbol).to(SortingQuestionStateProtobufSerializer)
});
